import type { StoreApi, UseBoundStore } from 'zustand';
import { MARKETS_FEED_DEFAULT_SORT } from '@/components/markets/markets-feed-sorts';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface MarketsSortState {
  /**
   * The `/markets` feed's current sort key. Mirrored from the feed page's
   * `sortBy` state so a market card can stamp it onto `markets_card_clicked`
   * analytics at click time WITHOUT taking `sortBy` as a prop — threading the
   * changing value through the card subtree busted the React Compiler memo and
   * re-rendered every visible card on each sort switch. Read non-reactively via
   * `getState()` in the click handler; nothing subscribes to it.
   */
  activeSort: string;
  setActiveSort: (sort: string) => void;
}

export const useMarketsSortStore: UseBoundStore<StoreApi<MarketsSortState>> =
  createTrackedStore<MarketsSortState>('useMarketsSortStore')((set) => ({
    activeSort: MARKETS_FEED_DEFAULT_SORT,
    setActiveSort: (sort: string): void => {
      set({ activeSort: sort });
    },
  }));
